export const verbs = [
  {
    "imperative": "arise",
    "simple": "arose",
    "participle": "arisen",
    "rus": "подниматься"
  },
  {
    "imperative": "awake",
    "simple": "awoke",
    "participle": "awoken",
    "rus": "пробуждать"
  },
  {
    "imperative": "be",
    "simple": "was",
    "participle": "been",
    "rus": "быть"
  },
  {
    "imperative": "bear",
    "simple": "bore",
    "participle": "born",
    "rus": "рожать, переносить"
  },
  {
    "imperative": "beat",
    "simple": "beat",
    "participle": "beaten",
    "rus": "бить"
  },
  {
    "imperative": "become",
    "simple": "became",
    "participle": "become",
    "rus": "становиться"
  },
  {
    "imperative": "begin",
    "simple": "began",
    "participle": "begun",
    "rus": "начинать"
  },
  {
    "imperative": "bend",
    "simple": "bent",
    "participle": "bent",
    "rus": "наклонять"
  },
  {
    "imperative": "bet",
    "simple": "bet",
    "participle": "bet",
    "rus": "заключать пари"
  },
  {
    "imperative": "bind",
    "simple": "bound",
    "participle": "bound",
    "rus": "связывать"
  },
  {
    "imperative": "bite",
    "simple": "bit",
    "participle": "bitten",
    "rus": "кусать"
  },
  {
    "imperative": "bleed",
    "simple": "bled",
    "participle": "bled",
    "rus": "кровоточить"
  },
  {
    "imperative": "blow",
    "simple": "blew",
    "participle": "blown",
    "rus": "дуть"
  },
  {
    "imperative": "break",
    "simple": "broke",
    "participle": "broken",
    "rus": "ломать"
  },
  {
    "imperative": "breed",
    "simple": "bred",
    "participle": "bred",
    "rus": "разводить животных"
  },
  {
    "imperative": "bring",
    "simple": "brought",
    "participle": "brought",
    "rus": "приносить"
  },
  {
    "imperative": "build",
    "simple": "built",
    "participle": "built",
    "rus": "строить"
  },
  {
    "imperative": "buy",
    "simple": "bought",
    "participle": "bought",
    "rus": "покупать"
  },
  {
    "imperative": "catch",
    "simple": "caught",
    "participle": "caught",
    "rus": "ловить"
  },
  {
    "imperative": "choose",
    "simple": "chose",
    "participle": "chosen",
    "rus": "выбирать"
  },
  {
    "imperative": "cling",
    "simple": "clung",
    "participle": "clung",
    "rus": "цепляться"
  },
  {
    "imperative": "come",
    "simple": "came",
    "participle": "come",
    "rus": "приходить"
  },
  {
    "imperative": "cost",
    "simple": "cost",
    "participle": "cost",
    "rus": "стоить"
  },
  {
    "imperative": "cut",
    "simple": "cut",
    "participle": "cut",
    "rus": "резать"
  },
  {
    "imperative": "deal",
    "simple": "dealt",
    "participle": "dealt",
    "rus": "вести дела"
  },
  {
    "imperative": "dig",
    "simple": "dug",
    "participle": "dug",
    "rus": "копать"
  },
  {
    "imperative": "do",
    "simple": "did",
    "participle": "done",
    "rus": "делать"
  },
  {
    "imperative": "draw",
    "simple": "drew",
    "participle": "drawn",
    "rus": "рисовать, тянуть"
  },
  {
    "imperative": "drink",
    "simple": "drank",
    "participle": "drunk",
    "rus": "пить"
  },
  {
    "imperative": "drive",
    "simple": "drove",
    "participle": "driven",
    "rus": "водить автомобиль"
  },
  {
    "imperative": "eat",
    "simple": "ate",
    "participle": "eaten",
    "rus": "кушать"
  },
  {
    "imperative": "fall",
    "simple": "fell",
    "participle": "fallen",
    "rus": "падать"
  },
  {
    "imperative": "feed",
    "simple": "fed",
    "participle": "fed",
    "rus": "кормить"
  },
  {
    "imperative": "feel",
    "simple": "felt",
    "participle": "felt",
    "rus": "чувствовать"
  },
  {
    "imperative": "fight",
    "simple": "fought",
    "participle": "fought",
    "rus": "бороться"
  },
  {
    "imperative": "find",
    "simple": "found",
    "participle": "found",
    "rus": "находить"
  },
  {
    "imperative": "flee",
    "simple": "fled",
    "participle": "fled",
    "rus": "сбегать"
  },
  {
    "imperative": "fly",
    "simple": "flew",
    "participle": "flown",
    "rus": "летать"
  },
  {
    "imperative": "forbid",
    "simple": "forbade",
    "participle": "forbidden",
    "rus": "запрещать"
  },
  {
    "imperative": "forget",
    "simple": "forgot",
    "participle": "forgotten",
    "rus": "забывать"
  },
  {
    "imperative": "forgive",
    "simple": "forgave",
    "participle": "forgiven",
    "rus": "прощать"
  },
  {
    "imperative": "freeze",
    "simple": "froze",
    "participle": "frozen",
    "rus": "замораживать"
  },
  {
    "imperative": "get",
    "simple": "got",
    "participle": "got",
    "rus": "получать"
  },
  {
    "imperative": "give",
    "simple": "gave",
    "participle": "given",
    "rus": "давать"
  },
  {
    "imperative": "go",
    "simple": "went",
    "participle": "gone",
    "rus": "идти"
  },
  {
    "imperative": "grow",
    "simple": "grew",
    "participle": "grown",
    "rus": "расти"
  },
  {
    "imperative": "hang",
    "simple": "hung",
    "participle": "hung",
    "rus": "висеть"
  },
  {
    "imperative": "have",
    "simple": "had",
    "participle": "had",
    "rus": "иметь"
  },
  {
    "imperative": "hear",
    "simple": "heard",
    "participle": "heard",
    "rus": "слышать"
  },
  {
    "imperative": "hide",
    "simple": "hid",
    "participle": "hidden",
    "rus": "прятать"
  },
  {
    "imperative": "hit",
    "simple": "hit",
    "participle": "hit",
    "rus": "ударять, попадать"
  },
  {
    "imperative": "hold",
    "simple": "held",
    "participle": "held",
    "rus": "держать"
  },
  {
    "imperative": "hurt",
    "simple": "hurt",
    "participle": "hurt",
    "rus": "причинять боль"
  },
  {
    "imperative": "keep",
    "simple": "kept",
    "participle": "kept",
    "rus": "сохранять, соблюдать"
  },
  {
    "imperative": "know",
    "simple": "knew",
    "participle": "known",
    "rus": "знать"
  },
  {
    "imperative": "lay",
    "simple": "laid",
    "participle": "laid",
    "rus": "класть"
  },
  {
    "imperative": "lead",
    "simple": "led",
    "participle": "led",
    "rus": "вести, лидировать"
  },
  {
    "imperative": "learn",
    "simple": "learnt",
    "participle": "learnt",
    "rus": "учиться, узнавать"
  },
  {
    "imperative": "leave",
    "simple": "left",
    "participle": "left",
    "rus": "покидать, оставлять"
  },
  {
    "imperative": "lend",
    "simple": "lent",
    "participle": "lent",
    "rus": "давать взаймы"
  },
  {
    "imperative": "let",
    "simple": "let",
    "participle": "let",
    "rus": "позволять"
  },
  {
    "imperative": "lie",
    "simple": "lay",
    "participle": "lain",
    "rus": "лежать"
  },
  {
    "imperative": "light",
    "simple": "lit",
    "participle": "lit",
    "rus": "зажигать, освещать"
  },
  {
    "imperative": "lose",
    "simple": "lost",
    "participle": "lost",
    "rus": "терять"
  },
  {
    "imperative": "make",
    "simple": "made",
    "participle": "made",
    "rus": "делать, мастерить"
  },
  {
    "imperative": "mean",
    "simple": "meant",
    "participle": "meant",
    "rus": "значить"
  },
  {
    "imperative": "meet",
    "simple": "met",
    "participle": "met",
    "rus": "встречать, знакомиться"
  },
  {
    "imperative": "pay",
    "simple": "paid",
    "participle": "paid",
    "rus": "платить"
  },
  {
    "imperative": "put",
    "simple": "put",
    "participle": "put",
    "rus": "класть, ставить"
  },
  {
    "imperative": "read",
    "simple": "read",
    "participle": "read",
    "rus": "читать"
  },
  {
    "imperative": "ride",
    "simple": "rode",
    "participle": "ridden",
    "rus": "ездить верхом"
  },
  {
    "imperative": "ring",
    "simple": "rang",
    "participle": "rung",
    "rus": "звонить"
  },
  {
    "imperative": "rise",
    "simple": "rose",
    "participle": "risen",
    "rus": "возрастать, подниматься"
  },
  {
    "imperative": "run",
    "simple": "ran",
    "participle": "run",
    "rus": "бежать"
  },
  {
    "imperative": "say",
    "simple": "said",
    "participle": "said",
    "rus": "сказать"
  },
  {
    "imperative": "see",
    "simple": "saw",
    "participle": "seen",
    "rus": "видеть"
  },
  {
    "imperative": "seek",
    "simple": "sought",
    "participle": "sought",
    "rus": "искать"
  },
  {
    "imperative": "sell",
    "simple": "sold",
    "participle": "sold",
    "rus": "продавать"
  },
  {
    "imperative": "send",
    "simple": "sent",
    "participle": "sent",
    "rus": "посылать"
  },
  {
    "imperative": "set",
    "simple": "set",
    "participle": "set",
    "rus": "устанавливать"
  },
  {
    "imperative": "shake",
    "simple": "shook",
    "participle": "shaken",
    "rus": "трясти"
  },
  {
    "imperative": "shine",
    "simple": "shone",
    "participle": "shone",
    "rus": "светить, сиять"
  },
  {
    "imperative": "shoot",
    "simple": "shot",
    "participle": "shot",
    "rus": "стрелять"
  },
  {
    "imperative": "show",
    "simple": "showed",
    "participle": "shown",
    "rus": "показывать"
  },
  {
    "imperative": "shrink",
    "simple": "shrank",
    "participle": "shrunk",
    "rus": "сжиматься"
  },
  {
    "imperative": "shut",
    "simple": "shut",
    "participle": "shut",
    "rus": "закрывать, затворять"
  },
  {
    "imperative": "sing",
    "simple": "sang",
    "participle": "sung",
    "rus": "петь"
  },
  {
    "imperative": "sit",
    "simple": "sat",
    "participle": "sat",
    "rus": "сидеть"
  },
  {
    "imperative": "sleep",
    "simple": "slept",
    "participle": "slept",
    "rus": "спать"
  },
  {
    "imperative": "slide",
    "simple": "slid",
    "participle": "slid",
    "rus": "скользить"
  },
  {
    "imperative": "smell",
    "simple": "smelt",
    "participle": "smelt",
    "rus": "пахнуть, нюхать"
  },
  {
    "imperative": "speak",
    "simple": "spoke",
    "participle": "spoken",
    "rus": "говорить"
  },
  {
    "imperative": "spell",
    "simple": "spelt",
    "participle": "spelt",
    "rus": "произносить или писать по буквам"
  },
  {
    "imperative": "spend",
    "simple": "spent",
    "participle": "spent",
    "rus": "тратить, проводить время"
  },
  {
    "imperative": "spill",
    "simple": "spilt",
    "participle": "spilt",
    "rus": "разлить"
  },
  {
    "imperative": "spin",
    "simple": "spun",
    "participle": "spun",
    "rus": "крутить"
  },
  {
    "imperative": "split",
    "simple": "split",
    "participle": "split",
    "rus": "разделять, раскалывать"
  },
  {
    "imperative": "spoil",
    "simple": "spoilt",
    "participle": "spoilt",
    "rus": "портить"
  },
  {
    "imperative": "spread",
    "simple": "spread",
    "participle": "spread",
    "rus": "разворачивать, распространять"
  },
  {
    "imperative": "stand",
    "simple": "stood",
    "participle": "stood",
    "rus": "стоять"
  },
  {
    "imperative": "steal",
    "simple": "stole",
    "participle": "stolen",
    "rus": "воровать"
  },
  {
    "imperative": "sting",
    "simple": "stung",
    "participle": "stung",
    "rus": "жалить"
  },
  {
    "imperative": "stink",
    "simple": "stank",
    "participle": "stunk",
    "rus": "вонять"
  },
  {
    "imperative": "strike",
    "simple": "struck",
    "participle": "struck",
    "rus": "бастовать, ударять"
  },
  {
    "imperative": "swear",
    "simple": "swore",
    "participle": "sworn",
    "rus": "клясться, ругаться"
  },
  {
    "imperative": "sweep",
    "simple": "swept",
    "participle": "swept",
    "rus": "подметать"
  },
  {
    "imperative": "swell",
    "simple": "swelled",
    "participle": "swollen",
    "rus": "опухать"
  },
  {
    "imperative": "swim",
    "simple": "swam",
    "participle": "swum",
    "rus": "плавать"
  },
  {
    "imperative": "take",
    "simple": "took",
    "participle": "taken",
    "rus": "брать"
  },
  {
    "imperative": "teach",
    "simple": "taught",
    "participle": "taught",
    "rus": "обучать"
  },
  {
    "imperative": "tear",
    "simple": "tore",
    "participle": "torn",
    "rus": "рвать"
  },
  {
    "imperative": "tell",
    "simple": "told",
    "participle": "told",
    "rus": "рассказывать"
  },
  {
    "imperative": "think",
    "simple": "thought",
    "participle": "thought",
    "rus": "думать"
  },
  {
    "imperative": "throw",
    "simple": "threw",
    "participle": "thrown",
    "rus": "бросать"
  },
  {
    "imperative": "understand",
    "simple": "understood",
    "participle": "understood",
    "rus": "понимать"
  },
  {
    "imperative": "wake",
    "simple": "woke",
    "participle": "woken",
    "rus": "будить"
  },
  {
    "imperative": "wear",
    "simple": "wore",
    "participle": "worn",
    "rus": "носить"
  },
  {
    "imperative": "win",
    "simple": "won",
    "participle": "won",
    "rus": "побеждать"
  },
  {
    "imperative": "wind",
    "simple": "wound",
    "participle": "wound",
    "rus": "обматывать, изгибаться"
  },
  {
    "imperative": "write",
    "simple": "wrote",
    "participle": "written",
    "rus": "писать"
  }
]
